"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  d: "M17 15h2v2h-2zm0-4h2v2h-2zm0-4h2v2h-2zm-3.26 0l1.26.84V7z"
}), _react.default.createElement("path", {
  d: "M10 3v1.51l2 1.33V5h9v14h-4v2h6V3z"
}), _react.default.createElement("path", {
  d: "M8.17 5.7L15 10.25V21H1V10.48L8.17 5.7zM10 19h3v-7.84L8.17 8.09 3 11.38V19h3v-6h4v6z"
}), _react.default.createElement("path", {
  d: "M10 19h3v-7.84L8.17 8.09 3 11.38V19h3v-6h4z",
  opacity: ".3"
})), 'HomeWorkTwoTone');

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/HomeWorkTwoTone.js
// module id = 3041
// module chunks = 0